// extracted by mini-css-extract-plugin
export default {"Container":"Federal_Container__7E-T6","section-1":"Federal_section-1__bYjG1","content":"Federal_content__85qYS","section-2":"Federal_section-2__2n-hJ"};